import { ActiveVehicle } from '../../core/models';

const ActionTypes = {
  SET_ACTIVE_VEHICLES: `[ACTIVE VEHICLE] Set Active Vehicles`,

  UPDATE_ACTIVE_VEHICLE_AFTER_UPDATING_ITS_INFO: `[ACTIVE VEHICLE] Update Active Vehicle After Updating Its Info`,
};

export class SetActiveVehiclesAction {
  static type = ActionTypes.SET_ACTIVE_VEHICLES;

  constructor(public payload: ActiveVehicle[]) {
  }
}

export class UpdateActiveVehicleAfterUpdatingItsInfoAction {
  static type = ActionTypes.UPDATE_ACTIVE_VEHICLE_AFTER_UPDATING_ITS_INFO;

  constructor(public payload: Partial<ActiveVehicle>) {
  }
}
